import AnimateOnScroll from "../AnimateOnScroll";

import teamInes from "@/assets/team-ines.jpg";
import teamNatalie from "@/assets/team-natalie.jpg";
import teamVesna from "@/assets/team-vesna.jpg";
import teamVanja from "@/assets/team-vanja.jpg";
import teamMarijana from "@/assets/team-marijana.jpg";

const localImages: Record<string, string> = {
  "team-ines": teamInes,
  "team-natalie": teamNatalie,
  "team-vesna": teamVesna,
  "team-vanja": teamVanja,
  "team-marijana": teamMarijana,
};

interface TeamMember {
  name: string;
  role: string;
  description?: string;
  image?: string;
  localImage?: string;
}

interface TeamSectionProps {
  heading: string;
  members: TeamMember[];
}

const TeamSection = ({ heading, members }: TeamSectionProps) => {
  return (
    <section className="mx-auto max-w-6xl px-6 py-12 md:py-16">
      <AnimateOnScroll>
        <h2 className="text-3xl font-bold md:text-4xl">{heading}</h2>
      </AnimateOnScroll>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2">
        {members.map((member, i) => {
          const imgSrc = member.localImage ? localImages[member.localImage] : member.image;
          return (
            <AnimateOnScroll
              key={i}
              animation="animate-scale-in"
              delay={`delay-${(i + 1) * 100}`}
            >
              <div className="rounded-3xl bg-card p-6 text-center shadow-sm">
                <div className="mx-auto h-48 w-48 overflow-hidden rounded-full shadow-md">
                  <img
                    src={imgSrc}
                    alt={member.name}
                    className="h-full w-full object-cover object-top"
                    loading="lazy"
                    width={192}
                    height={192}
                  />
                </div>
                <h3 className="mt-5 text-xl font-bold">{member.name}</h3>
                <p className="mt-1 font-body font-medium text-muted-foreground">{member.role}</p>
                {member.description && (
                  <p className="mt-4 font-body text-sm leading-relaxed text-foreground/80">
                    {member.description}
                  </p>
                )}
              </div>
            </AnimateOnScroll>
          );
        })}
      </div>
    </section>
  );
};

export default TeamSection;
